/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q15Inputs */

const et_faq_q15 = /** @type {(inputs: Faq_Q15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuidas ScalingWebs erineb tavalisest digiturundusagentuurist?`)
};

const en_faq_q15 = /** @type {(inputs: Faq_Q15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How is ScalingWebs different from a typical digital marketing agency?`)
};

/**
* | output |
* | --- |
* | "How is ScalingWebs different from a typical digital marketing agency?" |
*
* @param {Faq_Q15Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_q15 = /** @type {((inputs?: Faq_Q15Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q15Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_q15(inputs)
	return en_faq_q15(inputs)
});